import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useAuthStore } from '@/entities/auth';

/**
 * Guard для проверки выбора организации
 * Проверяет наличие текущей организации у авторизованного пользователя
 */
export const organizationGuard = (to: RouteLocationNormalized): NavigationGuardReturn => {
  const authStore = useAuthStore();
  const hasCurrentOrganization = !!authStore.currentOrganization;

  // По умолчанию организация требуется, если явно не указано requiresOrganization: false
  const requiresOrganization = to.meta.requiresOrganization ?? true;

  // Если роут требует организацию, но её нет - редирект на выбор локации
  if (requiresOrganization && !hasCurrentOrganization && to.name !== 'auth.location-switch') {
    return { name: 'auth.location-switch' };
  }

  return true;
};
